module.exports = __webpack_public_path__ + "static/img/publicite-en-ligne.12df681a.jpg";